import { Category } from '../../types'
import { fetchCategories } from '../../services/categories.service'
import createBaseStore from '../createStoreHelper'
import { getters } from './category.getters'

export const CategoryModule = createBaseStore<Category>({
  resourceName: 'category',
  plural: 'categories',
  apiCalls: {
    fetchAllApiCall: fetchCategories
  }
})

CategoryModule.getters = { ...CategoryModule.getters, ...getters }
